import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <SectionWrapper bgColor="bg-brand-guarantee" data-id="element-121">
      <div className="text-center" data-id="element-122">
        <ShieldCheckIcon className="w-16 h-16 text-brand-gold mx-auto" strokeWidth={1.5} data-id="element-123" />

        <h2 className="font-heading text-2xl md:text-3xl text-brand-gold font-bold mt-6" data-id="element-124">
          GARANTÍA TOTAL DE 7 DÍAS
        </h2>
      </div>

      <div className="mt-8 space-y-5 text-brand-muted text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto font-body" data-id="element-125">
        <p data-id="element-126">
          Si en los próximos 7 días sentís que el sistema no es lo que
          esperabas, un email es suficiente para recibir el reembolso completo.
        </p>
        <p className="text-brand-ivory font-semibold text-lg md:text-xl" data-id="element-127">
          Sin preguntas. Sin formularios. Sin demoras.
        </p>
        <p data-id="element-128">
          La garantía existe para que tomés la decisión desde la calma, no desde
          el miedo.
        </p>
      </div>
    </SectionWrapper>;
}